<template>
  <div class="resume-config">
    <h3>Paramètres du résumé de conversation</h3>

    <div class="form-group">
      <label>Activer le résumé automatique</label>
      <select v-model="localModel.enabled">
        <option value="yes">Oui</option>
        <option value="no">Non</option>
      </select>
    </div>

    <div class="form-group">
      <label>Fréquence de résumé</label>
      <select v-model="localModel.frequency">
        <option value="after_each">Après chaque message</option>
        <option value="periodic">Toutes les 5 minutes</option>
        <option value="end_only">À la fin de la conversation</option>
      </select>
    </div>

    <div class="form-group">
      <label>Format de résumé préféré</label>
      <select v-model="localModel.format">
        <option value="bullet_points">Points clés</option>
        <option value="paragraph">Paragraphe</option>
        <option value="both">Les deux</option>
      </select>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ResumeConfig',
  props: {
    modelValue: {
      type: Object,
      required: true
    }
  },
  emits: ['update:modelValue'],
  data() {
    return {
      localModel: {
        enabled: 'yes',
        frequency: 'periodic',
        format: 'paragraph'
      }
    }
  },
  watch: {
    modelValue: {
      immediate: true,
      handler(newVal) {
        this.localModel = JSON.parse(JSON.stringify(newVal))
      }
    },
    localModel: {
      deep: true,
      handler(val) {
        this.$emit('update:modelValue', val)
      }
    }
  }
}
</script>

<style scoped>
.resume-config {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.form-group {
  display: flex;
  flex-direction: column;
}

label {
  font-weight: 600;
  margin-bottom: 0.25rem;
}

select {
  padding: 8px;
  font-size: 1rem;
  border: 1px solid #d1d5db;
  border-radius: 6px;
}
</style>
